import React from 'react';
import ReactDOM from 'react-dom/client';
import { store } from 'store';
import 'store/logger';
import { RegisterMessageEventListener } from './api/api';
import { setAppStepAction } from './store/features/context/actions';
import { AppSteps } from './api/api.type';
import { Provider } from 'react-redux';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

RegisterMessageEventListener();

if (window === window.parent) store.dispatch(setAppStepAction(AppSteps.EDIT));
